import { FormMapperConfig } from './types';

export const coiMapperConfig: FormMapperConfig = {
  formType: 'coi',
  
  patterns: {
    'form.coi.relationship.employees': 'among-employees',
    'form.coi.relationship.customers': 'with-customers',
    'form.coi.relationship.competitors': 'with-competitors',
    'form.coi.relationship.officials': 'government',
    'form.coi.otherOccupation.advisory': 'advisory',
    'form.coi.otherOccupation.employment': 'outside-employment',
    'form.coi.personalInvestment': 'personal-investment'
  },

  fieldConfigs: {
    'among-employees': [
      'form.coi.relationship.employees.otherPartyName.question',
      'form.coi.relationship.type.question',
      'form.coi.relationship.employees.details.question'
    ],
    'with-customers': [
      'form.coi.relationship.customers.otherPartyName.question',
      'form.coi.relationship.customers.partyType.question', 
      'form.coi.relationship.type.question',
      'form.coi.relationship.customers.companyName.question',
      'form.coi.relationship.customers.details.question'
    ],
    'with-competitors': [
      'form.coi.relationship.competitors.otherPartyName.question',
      'form.coi.relationship.type.question',
      'form.coi.relationship.competitors.companyName.question', 
      'form.coi.relationship.competitors.details.question'
    ],
    'government': [
      'form.coi.relationship.officials.otherPartyName.question',
      'form.coi.relationship.officials.jobTitle.question',
      'form.coi.relationship.officials.organizationName.question',
      'form.coi.relationship.officials.details.question'
    ],
    'advisory': [
      'form.coi.relationship.employees.otherPartyName.question',
      'form.coi.otherOccupation.advisory.companyName.question',
      'form.coi.otherOccupation.advisory.awareNegotiations.question',
      'form.coi.otherOccupation.advisory.involvedNegotiations.question',
      'form.coi.otherOccupation.advisory.details.question'
    ],
    'outside-employment': [
      'form.coi.otherOccupation.employment.occupation.question',
      'form.coi.otherOccupation.employment.employmentType.question',
      'form.coi.otherOccupation.employment.companyName.question',
      'form.coi.otherOccupation.employment.isCompetitor.question',
      'form.coi.otherOccupation.employment.foundThroughABI.question',
      'form.coi.otherOccupation.employment.details.question'
    ],
    'personal-investment': [
      'form.coi.relationship.employees.otherPartyName.question',
      'form.coi.personalInvestment.companyName.question',
      'form.coi.personalInvestment.awareNegotiations.question',
      'form.coi.personalInvestment.details.question'
    ]
  },

  translationKeys: {
    'form.coi.relationship.employees.otherPartyName.question': 'coi.fields.other_party_involved',
    'form.coi.relationship.type.question': 'coi.fields.relationship_type',
    'form.coi.relationship.employees.details.question': 'common.description',
    'form.coi.relationship.customers.otherPartyName.question': 'coi.fields.other_party_involved',
    'form.coi.relationship.customers.partyType.question': 'coi.fields.party_type',
    'form.coi.relationship.customers.companyName.question': 'coi.fields.company_name',
    'form.coi.relationship.customers.details.question': 'common.description',
    'form.coi.relationship.competitors.otherPartyName.question': 'coi.fields.other_party_involved',
    'form.coi.relationship.competitors.companyName.question': 'coi.fields.company_name',
    'form.coi.relationship.competitors.details.question': 'common.description',
    'form.coi.relationship.officials.otherPartyName.question': 'coi.fields.other_party_involved',
    'form.coi.relationship.officials.jobTitle.question': 'coi.fields.job_title_other_party',
    'form.coi.relationship.officials.organizationName.question': 'coi.fields.organization_name',
    'form.coi.relationship.officials.details.question': 'common.description',
    'form.coi.otherOccupation.advisory.companyName.question': 'coi.fields.company_name',
    'form.coi.otherOccupation.advisory.awareNegotiations.question': 'coi.fields.aware_negotiations',
    'form.coi.otherOccupation.advisory.involvedNegotiations.question': 'coi.fields.involved_negotiations',
    'form.coi.otherOccupation.advisory.details.question': 'common.description',
    'form.coi.otherOccupation.employment.occupation.question': 'coi.fields.other_occupation',
    'form.coi.otherOccupation.employment.employmentType.question': 'coi.fields.employment_type',
    'form.coi.otherOccupation.employment.companyName.question': 'coi.fields.company_name',
    'form.coi.otherOccupation.employment.isCompetitor.question': 'coi.fields.is_company',
    'form.coi.otherOccupation.employment.foundThroughABI.question': 'coi.fields.found_through_abi',
    'form.coi.otherOccupation.employment.details.question': 'common.description',
    'form.coi.personalInvestment.companyName.question': 'coi.fields.company_name',
    'form.coi.personalInvestment.awareNegotiations.question': 'coi.fields.aware_negotiations',
    'form.coi.personalInvestment.details.question': 'common.description'
  },

  displayLabels: {
    'form.coi.relationship.employees.otherPartyName.question': 'Other Party Involved',
    'form.coi.relationship.type.question': 'Relationship Type',
    'form.coi.relationship.employees.details.question': 'Description',
    'form.coi.relationship.customers.otherPartyName.question': 'Other Party Involved',
    'form.coi.relationship.customers.partyType.question': 'Party Type',
    'form.coi.relationship.customers.companyName.question': 'Company Name',
    'form.coi.relationship.customers.details.question': 'Description',
    'form.coi.relationship.competitors.otherPartyName.question': 'Other Party Involved',
    'form.coi.relationship.competitors.companyName.question': 'Company Name',
    'form.coi.relationship.competitors.details.question': 'Description',
    'form.coi.relationship.officials.otherPartyName.question': 'Other Party Involved',
    'form.coi.relationship.officials.jobTitle.question': 'Job title of the other party involved',
    'form.coi.relationship.officials.organizationName.question': 'Organization Name',
    'form.coi.relationship.officials.details.question': 'Description',
    'form.coi.otherOccupation.advisory.companyName.question': 'Company Name',
    'form.coi.otherOccupation.advisory.awareNegotiations.question': 'Are You aware...?',
    'form.coi.otherOccupation.advisory.involvedNegotiations.question': 'Are You involved...?',
    'form.coi.otherOccupation.advisory.details.question': 'Description',
    'form.coi.otherOccupation.employment.occupation.question': 'What is the other occupation?',
    'form.coi.otherOccupation.employment.employmentType.question': 'Will you be working for another company or will you be self-employed?',
    'form.coi.otherOccupation.employment.companyName.question': 'Company Name',
    'form.coi.otherOccupation.employment.isCompetitor.question': 'Is this company:',
    'form.coi.otherOccupation.employment.foundThroughABI.question': 'Was this opportunity found through ABI?',
    'form.coi.otherOccupation.employment.details.question': 'Description',
    'form.coi.personalInvestment.companyName.question': 'Company Name',
    'form.coi.personalInvestment.awareNegotiations.question': 'Are You aware...?',
    'form.coi.personalInvestment.details.question': 'Description'
  }
};

export type CoiSubcategory = 'among-employees' | 'with-customers' | 'with-competitors' | 'government' | 'advisory' | 'outside-employment' | 'personal-investment';
